import { configureStore } from "@reduxjs/toolkit";
import loaderReducer from "./loading/index";
import userReducer from "./user/index";
import cardReducer from "./card/index";
import offerReducer from "./offer/index";
import categoryReducer from "./category/index";
import bankReducer from "./bank/index";
import networkReducer from "./network/index";
import outletReducer from "./outlet/index";
import authReducer from "./auth/index";
import contactReducer from "./contact/index";
import feedbackReducer from "./feedback/index";
import notificationReducer from "./notification/index";
import dashboardReducer from "./dashboard/index";
import privacyPolicyReducer from "./privacyPolicy/index";
import CSVReducer from "./csv/index";
import crawlOutletReducer from "./crawlOutletData/index";
import crawlAllDataReducer from "./crawlAllData/index";
import crawOfferReducer from "./crawlOfferData/index";
import heroBannerReducer from "./homepageConfig/heroBanner";
import dontMissOutReducer from "./homepageConfig/dontMissOut";
import cityReducer from "./city/index";
import selectedOffersReducer from "./homepageConfig/selectedOffers";
import topPickReducer from "./homepageConfig/topPick";
import settingsReducer from "./settings/index";
import welcomeMessageReducer from "./homepageConfig/welcomeMessage";
import crawlCardReducer from "./crawlCardData/index";
import n8nCrawlConfigReducer from "./n8nCrawlConfig/index";
import searchReportsReducer from "./searchReports/index";
import versionControlReducer from "./versionControl/index";
import outletDuplicateReducer from "./outletDuplicate/index";
import cardDiscoveryReducer from "./cardDiscovery/index";

export default configureStore({
  reducer: {
    loader: loaderReducer,
    user: userReducer,
    card: cardReducer,
    offer: offerReducer,
    outlet: outletReducer,
    crawlOutlet: crawlOutletReducer,
    crawlOffer: crawOfferReducer,
    crawlCard: crawlCardReducer,
    crawlAllData: crawlAllDataReducer,
    categories: categoryReducer,
    welcomeMessage: welcomeMessageReducer,
    heroBanner: heroBannerReducer,
    dontMissOut: dontMissOutReducer,
    selectedOffers: selectedOffersReducer,
    topPick: topPickReducer,
    bank: bankReducer,
    city: cityReducer,
    network: networkReducer,
    auth: authReducer,
    contact: contactReducer,
    feedback: feedbackReducer,
    notification: notificationReducer,
    dashboard: dashboardReducer,
    privacyPolicy: privacyPolicyReducer,
    CSV: CSVReducer,
    settings: settingsReducer,
    n8nCrawlConfig: n8nCrawlConfigReducer,
    searchReports: searchReportsReducer,
    versionControl: versionControlReducer,
    outletDuplicate: outletDuplicateReducer,
    cardDiscovery: cardDiscoveryReducer
  },
});
